export default {
    setFilters: (state, resp) => {
        state.filter = Object.assign({}, state.filter, resp);
    },
    setSubscriptionStatus: (state, status) => {
        state.subscriptionStatus = status;
    },
}